<template>
  <vs-upload v-bind="{...$props}" ref="upload"
             :action="config.api + action"
    @on-success="onSuccess"
    @on-delete="emitChange"
  />
</template>
<script>
export default {
  name: "upload",
  inheritAttrs: false,
  model: {
    props: 'value',
    event: 'change'
  },
  computed: {
    value: {
      get() {
        const $up = this.$refs.upload
        const rms = $up.itemRemove
        const list = $up.srcs.filter((_, i) => !~rms.indexOf(i)).map(i => i.src)
        if (this.singleUpload) {
          return list.length ? list[0] : ''
        }
        return list
      },
      set(v) {
    
        if (Array.isArray(v)) {
          this.$refs.upload.srcs = v.map(i => ({
            "src": i,
            "orientation":"w",
            "percent":100,
            "error":false,
            "remove":null
          }))
        } else if(typeof v === 'string') {
          this.$refs.upload.srcs = [{
            "src": v,
            "orientation":"w",
            "percent":100,
            "error":false,
            "remove":null
          }]
        }
        this.$refs.upload.filesx = this.$refs.upload.srcs.filter(i => i)
        this.$refs.upload.itemRemove = []
      }
    },
  },

  props: {
    config: {
      type: Object,
      default: () => window.__CONFIG__,
    },
    accept: {
      default: "*",
      type: String
    },
    // value: [Array, String],
    fileName: {
      default: 'file',
      type: String
    },
    text: {
      default: "上传",
      type: String
    },
    limit: {
      default: null,
      type: [Number, String]
    },
    action: {
      default: null,
      type: String
    },
    headers: {
      default: null,
      type: Object
    },
    data: {
      default: null,
      type: Object
    },
    automatic: {
      default: false,
      type: Boolean
    },
    showUploadButton: {
      default: true,
      type: Boolean
    },
    singleUpload: {
      default: true,
      type: Boolean
    },
    multiple: Boolean
  },
  mounted() {

    this.$watch("$attrs.value", this.setValue)
    this.$watch("$refs.upload.srcs", v => {
      this.$emit('change', this.value)
    });
    if (this.$attrs.value) {
      this.setValue(this.$attrs.value)
    }
  },
  methods: {
    setValue(v) {
      if (this.singleUpload && v) {
        this.value = [v]
        return
      }
      if (Array.isArray(v) && (v.length != this.value.length)) {
        this.value = v
      }
    },
    onSuccess(e) {
      this.$emit('on-success', e)
      const res = JSON.parse(e.target.responseText)
      if (this.singleUpload) {
        this.value = [res.data.path]
      } else {
        this.value = [
          ...this.value,
          ...res.data.paths,
        ].filter(i => i.indexOf('data:') !== 0)
      }
      this.$emit('change', this.value)
    },
    emitChange() {
      setTimeout(() => {
        this.$emit('change', this.value)
      }, 400);
    }
  }
};
</script>